import { render, staticRenderFns } from "./AlertNavItem.vue?vue&type=template&id=378ca3b4"
import script from "./AlertNavItem.vue?vue&type=script&lang=ts"
export * from "./AlertNavItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports